import { useEffect, useState } from 'react';

function isTextField(el: Element | null): boolean {
  if (!el) return false;
  const tag = el.tagName;
  return tag === 'INPUT' || tag === 'TEXTAREA' || (el as HTMLElement).isContentEditable;
}

/** True while a text input / textarea is focused — i.e. the on-screen keyboard
 *  is (about to be) open. Used to hide the fixed bottom tab bar so it doesn't
 *  cover the field the user is typing in (e.g. the booking comment). */
export function useTextInputFocused(): boolean {
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    const onFocusIn = (e: FocusEvent) => {
      if (isTextField(e.target as Element)) setFocused(true);
    };
    const onFocusOut = () => {
      // Defer: when focus jumps between two fields, activeElement is briefly
      // <body>; re-checking on the next tick avoids a flicker of the tab bar.
      setTimeout(() => setFocused(isTextField(document.activeElement)), 0);
    };
    document.addEventListener('focusin', onFocusIn);
    document.addEventListener('focusout', onFocusOut);
    return () => {
      document.removeEventListener('focusin', onFocusIn);
      document.removeEventListener('focusout', onFocusOut);
    };
  }, []);

  return focused;
}
